import React, { useState } from 'react';
import { Button, Form, Input, DatePicker, Row, Col, Modal, InputNumber } from 'antd';
//经度纬度
import Getlnglat from '@/components/Getlnglat'
//mobx
import { useStore } from '@/store';
import { observer } from 'mobx-react-lite';
import { set, runInAction } from 'mobx';

import 'moment/locale/zh-cn';
import locale from 'antd/es/date-picker/locale/zh_CN';
import moment from 'moment'

const WarehouseNewly = () => {
    //mobx
    const { ShedsStore } = useStore()
    // 取消按钮
    const [form] = Form.useForm();

    //日期
    const [timea, setTimea] = useState('')
    const [timeb, setTimeb] = useState('')
    const onChangetimea = (date, dateString) => {
        setTimea(dateString)
        setTimeb('')
        form.setFieldsValue({
            end_date: '',
        })
    }
    const onchangetimeb = (date, dateString) => {
        setTimeb(dateString)
    }
    const disabledDate = (current) => {
        let times = timea
        return current && current <= moment(times)
    }


    //表单提交
    const onFinish = async (values) => {
        if (values.start_date) {
            values.start_date = moment(values.start_date).format('YYYY/MM/DD')
        }
        if (values.end_date) {
            values.end_date = moment(values.end_date).format('YYYY/MM/DD')
        }
        await ShedsStore.getAddSheds(values)
        runInAction(() => {
            set(ShedsStore, { isAshow: false })
        })
    };
    //获取经纬度
    const getJd = (values) => {
        runInAction(() => {
            set(ShedsStore, { isJdWd: true })
        })
    }
    //经度纬度
    const getGetlnglat = (value) => {
        form.setFieldsValue({
            lat: value[0],
            lng: value[1],
        });
    }
    //表单取消
    const onReset = () => {
        form.resetFields();
        runInAction(() => {
            set(ShedsStore, { isAshow: false })
        })
    };


    //点X取消
    const handleOk = () => {
        runInAction(() => {
            set(ShedsStore, { isJdWd: false })
        })
    };
    return (
        <>
            <Form
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 14,
                }}
                form={form}
                onFinish={onFinish}
            >
                <Form.Item
                    label="名称"
                    name="house_name"
                    rules={[
                        {
                            required: true,
                            message: '请输入名称',
                        },
                    ]}
                >
                    <Input placeholder="" />
                </Form.Item>
                <Form.Item label="地理坐标"
                    // name="lng"
                    rules={[
                        {
                            required: true,
                            message: "",
                        },
                    ]}
                >
                    <Row gutter={24}>
                        <Col span={8}>
                            <Form.Item noStyle name="lat"
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入经度"
                                    },
                                ]}
                            >
                                <Input placeholder="经度" />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item noStyle name="lng"
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入纬度",
                                    },
                                ]}
                            >
                                <Input placeholder="纬度" />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Button type='primary' onClick={getJd}>获取精纬度</Button>
                        </Col>
                    </Row>
                </Form.Item>
                <Modal
                    title="获取坐标"
                    bodyStyle={{ padding: '0' }}
                    key={new Date()}
                    width="800px"
                    open={ShedsStore.isJdWd}
                    onCancel={handleOk}
                    footer={[
                        <Button key="submit" type="primary" onClick={handleOk}>
                            确认
                        </Button>,
                    ]}
                >
                    <Getlnglat height='600px' value={[ShedsStore.valueData.lat, ShedsStore.valueData.lng]} onChange={getGetlnglat} />
                </Modal>
                <Form.Item
                    label="面积"
                    name="area"
                    rules={[
                        {
                            required: true,
                            pattern: new RegExp(/^(([1-9]\d*)|\d)(\.\d{1,2})?$/, 'g'), // 只能输入数字跟小数点 两位小数
                            message: '请输入面积(最多输入到小数点后两位)',
                        },
                    ]}
                >
                    <InputNumber min={0} />
                </Form.Item>
                <Form.Item
                    label="开始日期"
                    name="start_date"
                    rules={[
                        {
                            required: true,
                            message: "请选择开始时间"
                        },
                    ]}
                >
                    <DatePicker
                        placeholder="请选择开始时间"
                        locale={locale}
                        format="YYYY-MM-DD"
                        onChange={onChangetimea}
                    />
                </Form.Item>
                <Form.Item
                    label="结束日期"
                    name="end_date"
                    rules={[
                        {
                            required: true,
                            message: "请选择结束时间"
                        },
                    ]}
                >
                    <DatePicker
                        placeholder="请选择结束时间"
                        locale={locale}
                        format="YYYY-MM-DD"
                        onChange={onchangetimeb}
                        disabledDate={disabledDate}
                    />
                </Form.Item>
                <Form.Item
                    label="种植品种"
                    name="plant"
                    rules={[
                        {
                            required: true,
                            message: '请输入种植品种',
                        },
                    ]}
                >
                    <Input placeholder="请输入种植品种" />
                </Form.Item>
                <Form.Item
                    label="编号"
                    name="code"
                    rules={[
                        {
                            required: true,
                            message: '请输入编号',
                        },
                    ]}
                >
                    <Input placeholder="请输入编号" />
                </Form.Item>
                {/* <Form.Item
                    label="盛大大棚ID"
                    name="sdcode"
                    rules={[
                        {
                            required: true,
                            message: '请输入盛大大棚ID',
                        },
                    ]}
                >
                    <Input placeholder="请输入盛大大棚ID" />
                </Form.Item> */}
                <Form.Item
                    label="视频观察地址"
                    name="videourl"
                    rules={[
                        {
                            required: true,
                            message: '请输入视频观察地址',
                        },
                    ]}
                >
                    <Input placeholder="请输入视频观察地址" />
                </Form.Item>
                <Form.Item wrapperCol={{ offset: 6 }}>
                    <Button type="primary" htmlType="submit">
                        提交
                    </Button>
                    <Button htmlType="button" onClick={onReset} style={{ marginLeft: '15px' }}>
                        取消
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}
export default observer(WarehouseNewly)